import { convertToYMD } from '../../helpers/date.js';

export type SupportedInput = HTMLInputElement | HTMLTextAreaElement;

export function getSupportedInputValue<T extends SupportedInput>(input: T): string {
  if (input instanceof HTMLInputElement) {
    return getInputValue(input);
  }

  // Assume it's a textarea if not an input
  return input.value;
}

export function formDataFrom(supportedInput: SupportedInput, name: string): FormData {
  const formData = new FormData();
  const value = getSupportedInputValue(supportedInput);
  formData.append(name, value);
  return formData;
}

function getInputValue(input: HTMLInputElement): string {
  if (input.type === 'radio') {
    const siblings = Array.from(document.querySelectorAll<HTMLInputElement>(`input[name='${input.name}']`));
    const checkedSibling = siblings.find((sibling) => sibling.checked);
    return checkedSibling ? checkedSibling.value : '';
  }

  if (input.type === 'checkbox') {
    return input.checked ? input.value : '';
  }

  if (input.classList.contains('input-date') && !input.classList.contains('input-date--time')) {
    return convertToYMD(new Date(input.value));
  }

  return input.value;
}
